import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@katalon-studio/katalon-ui/v2';
import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

export const ToggleRenewalConfirmDialog = (
  { productName, autoRenew, open, onClose, toggleAutoRenew }: {
    productName: string;
    autoRenew: boolean;
    open: boolean;
    onClose: () => void;
    toggleAutoRenew: () => void;
  },
) => (
  <Dialog open={open}>
    <DialogTitle>
      <Box
        display="flex"
        flexDirection="row"
        alignContent="center"
        alignItems="center"
        justifyContent="space-between"
      >
        <Box>
          <FormattedMessage
            id={autoRenew
              ? 'page.subscription.toggle.auto.renew.turn.off.title'
              : 'page.subscription.toggle.auto.renew.turn.on.title'}
          />
        </Box>
        <Box>
          <IconButton
            color="primary"
            onClick={onClose}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="flex-start"
      >
        <Typography variant="body1">
          <FormattedMessage
            id={autoRenew
              ? 'page.subscription.toggle.auto.renew.turn.off.desc1'
              : 'page.subscription.toggle.auto.renew.turn.on.desc1'}
            values={{ productName: (<FormattedMessage id={`feature.${productName}.product.name`} />) }}
          />
        </Typography>
        <Typography variant="body1" paddingY={2}>
          <FormattedMessage
            id={autoRenew
              ? 'page.subscription.toggle.auto.renew.turn.off.desc2'
              : 'page.subscription.toggle.auto.renew.turn.on.desc2'}
          />
        </Typography>
        <Typography variant="body1">
          <FormattedMessage
            id="page.subscription.toggle.auto.renew.continue.desc"
          />
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions>
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="flex-end"
        width="100%"
        padding={2}
      >
        <Button
          size="medium"
          color="primary"
          variant="contained"
          onClick={onClose}
        >
          <FormattedMessage id="page.subscription.toggle.auto.renew.cancel.btn" />
        </Button>
        <Button
          size="medium"
          color="primary"
          variant="contained"
          onClick={toggleAutoRenew}
          sx={{
            marginLeft: 2,
          }}
        >
          <FormattedMessage
            id={autoRenew
              ? 'page.subscription.toggle.auto.renew.turn.off.btn'
              : 'page.subscription.toggle.auto.renew.turn.on.btn'}
          />
        </Button>
      </Box>
    </DialogActions>
  </Dialog>
);
